import { Delete24Regular } from "@fluentui/react-icons";
import { ActionButton } from "../ActionButton";

import styles from "./ClearChatButton.module.css";

interface Props {
  className?: string;
  onClick: () => void;
  disabled?: boolean;
  linkMode?: boolean;
}

const userLanguage = navigator.language;
let reiniciar_text = '';
if (userLanguage.startsWith('pt')) {
  reiniciar_text = 'Reiniciar Conversa';
} else if (userLanguage.startsWith('es')) {
  reiniciar_text = 'Reiniciar conversación';
} else {
  reiniciar_text = 'Reiniciar conversación';
}

export const ClearChatButton = ({ className, disabled, onClick, linkMode }: Props) => {
  if (linkMode) {
    return (
      <button className={`${styles.container} ${className ?? ""} ${disabled && styles.disabled} ${styles.linkMode}`} onClick={onClick} disabled={disabled}>
        <span className={styles.text}>{reiniciar_text}</span>
      </button>
    );
  }

  return (
    <ActionButton
      variant="secondary"
      onClick={onClick}
      disabled={disabled}
      className={className ?? ""}
      icon={<Delete24Regular />}
    >
      {reiniciar_text}
    </ActionButton>
  );
};
